import React, {useState, useEffect} from "react";
import DashboardLayout from "../../layouts/Dashboard";

import { ObjectReferralCRUDTable, PageFooter } from "./../../components";
import { useLocation } from 'react-router-dom';
import { LoadingButton } from "@mui/lab";
import { anObjectReferralCRUD } from "../../http";
import XLSX from "xlsx-js-style";
import { formatDate, MOMENT_FORMAT_DATE_DMYHM_DOTS } from "../../functions/formatters";
import { mapReferralObjectProbeType } from "../../functions/viewDataMap";

export const ObjectReferralTable = () => {
  const location = useLocation()
  const [stateId, setStateId] = useState(location?.search?.split('=')[1])
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState({});

  useEffect(() => {
      if (location?.search) {
        setStateId(location?.search?.split('=')[1])
      } else {
        setStateId(null);
      }
  }, [location])

  const handleExcel = async () => {
    const data = (await anObjectReferralCRUD.search({
        paging: {skip: 0, take: 10000},
        filter: filter,
        includes: ["Protocols"]
    }))?.result;
    const thinBorder = {style: 'thin', color: 'auto'};
    const thinBorders = {top: thinBorder, bottom: thinBorder, left: thinBorder, right: thinBorder};
    const thickBorder = {style: 'medium', color: 'auto'};
    const thickBorders = {top: thickBorder, bottom: thickBorder, left: thickBorder, right: thickBorder};
    const signatureBorders = {bottom: thickBorder};
    const right8 = {alignment: {horizontal: 'right', wrapText: true}, font: {sz: 8}};
    const center10 = {alignment: {horizontal: 'center'}, font: {sz: 10}};
    const centerTotal = {alignment: {horizontal: 'center', wrapText: true}, font: {sz: 10}};
    const centerBold = {alignment: {horizontal: 'center'}, font: {bold: true}};
    const centerBold10 = {alignment: {horizontal: 'center'}, font: {sz: 10, bold: true}};
    const centerBold10_2 = {
        alignment: {horizontal: 'center', vertical: 'center', wrapText: true},
        border: thinBorders,
        font: {sz: 9, bold: true}
    };

    const wb = XLSX.utils.book_new();

    const cell = (text) => {
      return {
        t: "s",
        v: text,
        s: center10
      };
    }

    const aoa = [
      [
      cell("№"),      
      cell("Номер"),
      cell("Объект"),
      cell("Филиал"),
      cell("Лаборатория"),
      cell("Создано"),
      cell("Статус"),
      cell("Ответственный"),
      cell("Исполнитель"),
      cell("Автор"),
      cell("Вид пробы"),
      cell("Протоколы")
      ]
    ];
    for (let i = 0; i < data.length; i++) {
      const item = data[i];

      aoa.push([
        cell(item.id),
        cell(item.number),
        cell(item.targetObject?.name),
        cell(item.filial?.name),
        cell(item.department?.name),
        cell(formatDate(item.createdAt, MOMENT_FORMAT_DATE_DMYHM_DOTS)),
        cell(item.state?.name),
        cell(item.responsible?.fullName || "-"),
        cell(item.performer?.fullName || "-"),
        cell(item.createdBy?.fullName || "-"),
        cell(item.probeType ? (
          mapReferralObjectProbeType(item.probeType)
        ) : (
          <span style={{ color: "gray" }}>Не задана</span>
        )),
        cell(item.protocols.map(_ => _.number).join(", "))
      ]);
    }

    const sheet = XLSX.utils.aoa_to_sheet(aoa);
    sheet['!cols'] = [
      {width: 14}, {width: 14}, {width: 14}, {width: 14},
      {width: 14}, {width: 14}, {width: 14}, {width: 14},
      {width: 14}, {width: 14}, {width: 14}, {width: 14}
    ];
    sheet['!rows'] = [{hpx: 60, hpt: 10}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {hpx: 60, hpt: 10}];
    //sheet['!merges'] = merges;
    XLSX.utils.book_append_sheet(wb, sheet, 'Отчет');
    const output = await XLSX.write(wb, {type: 'array'});
    let blob = await new Blob([output], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
    let objectUrl = URL.createObjectURL(blob);
    const link = document.createElement('a')
    link.href = objectUrl
    link.download = `Госзаказ.xlsx`
    document.body.appendChild(link)
    link.click()
    link.remove()
  }

  return (
    <DashboardLayout>
      <ObjectReferralCRUDTable stateId={stateId} onFilterChanged={setFilter}/>
      <PageFooter style={{justifyContent: 'flex-start'}}>
          {<LoadingButton loading={loading} sx={{marginLeft: 3}} onClick={handleExcel}>
              Скачать отчет (excel)
          </LoadingButton>}
      </PageFooter>
    </DashboardLayout>
  )
};
